import { baseApi } from '../apiProvider';
import { ResponseMission } from '../models/response/responseMission';
import { RequestMissionPrize } from '../models/request/requestMission';

// Mission API
const missionAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // get missions data
    getMissions: builder.query<ResponseMission[], void>({
      query: () => ({
        url: '/v0/missions?verify=false',
        method: 'GET',
      }),
      providesTags: ['Mission'],
      keepUnusedDataFor: 0,
    }),
    // receive mission prize
    receiveMissionPrize: builder.mutation<ResponseMission, RequestMissionPrize>(
      {
        query: (params: RequestMissionPrize) => ({
          url: `/v0/missions/${params.id}/prize?verify=${params.verify}`,
          method: 'POST',
        }),
        invalidatesTags: ['Mission', 'GiftBonus'],
      },
    ),
  }),
  overrideExisting: false,
});

export const { useGetMissionsQuery, useReceiveMissionPrizeMutation } =
  missionAPI;
